import { STPackage, STPackageMeta, STPackageType, STPricingType } from './STPackage.js';
/**
 * Package bundle are packages that you can buy
 */
export var STPackageBundle;
(function (STPackageBundle) {
    // Webshop package (max 10 webshops)
    STPackageBundle["Webshops"] = "Webshops";
    // Full members package
    STPackageBundle["Members"] = "Members";
    // One webshop package (max 1 webshop)
    STPackageBundle["SingleWebshop"] = "SingleWebshop";
    STPackageBundle["TrialMembers"] = "TrialMembers";
    STPackageBundle["TrialWebshops"] = "TrialWebshops";
})(STPackageBundle || (STPackageBundle = {}));
export class STPackageBundleHelper {
    static getTitle(bundle) {
        switch (bundle) {
            case STPackageBundle.Members: return $t(`%Om`);
            case STPackageBundle.Webshops: return $t(`%1Hk`);
        }
        return '?';
    }
    static getDescription(bundle) {
        switch (bundle) {
            case STPackageBundle.Members: return $t(`%1Hn`);
            case STPackageBundle.Webshops: return $t(`%1Ho`);
        }
        return '?';
    }
    static isPublic(bundle) {
        switch (bundle) {
            case STPackageBundle.Members: return true;
            case STPackageBundle.Webshops: return true;
        }
        return false;
    }
    static requiresMandate(bundle) {
        switch (bundle) {
            case STPackageBundle.Members: return true;
            case STPackageBundle.Webshops: return true;
        }
        return false;
    }
    /**
     * If you buy a package that is not combineable with an existing one, should it throw an error?
     */
    static isStackable(bundle, pack) {
        switch (bundle) {
            case STPackageBundle.TrialMembers: {
                // Not allowed to start a trial even if pack is expired
                return false;
            }
            case STPackageBundle.TrialWebshops: {
                // Not allowed to start a trial again if pack is expired
                return false;
            }
        }
        return true;
    }
    static isAlreadyBought(bundle, pack) {
        switch (bundle) {
            case STPackageBundle.Members: {
                if (pack.meta.type === STPackageType.Members) {
                    // Already bought
                    return true;
                }
                return false;
            }
            case STPackageBundle.Webshops: {
                if (pack.meta.type === STPackageType.Webshops) {
                    // Already bought
                    return true;
                }
                if (pack.meta.type === STPackageType.SingleWebshop) {
                    // Already bought
                    return true;
                }
                return false;
            }
            case STPackageBundle.SingleWebshop: {
                if (pack.meta.type === STPackageType.SingleWebshop || pack.meta.type === STPackageType.Webshops) {
                    // Already bought
                    return true;
                }
                return false;
            }
        }
        return false;
    }
    static isInTrial(bundle, pack) {
        switch (bundle) {
            case STPackageBundle.Members: {
                if (pack.meta.type === STPackageType.TrialMembers) {
                    // Already bought
                    return true;
                }
                return false;
            }
            case STPackageBundle.Webshops: {
                if (pack.meta.type === STPackageType.TrialWebshops) {
                    // Already bought
                    return true;
                }
                return false;
            }
            case STPackageBundle.SingleWebshop: {
                if (pack.meta.type === STPackageType.TrialWebshops) {
                    // Already bought
                    return true;
                }
                return false;
            }
        }
        return false;
    }
    static isCombineable(bundle, pack) {
        switch (bundle) {
            case STPackageBundle.Members: {
                if (pack.meta.type === STPackageType.Members) {
                    // Already bought
                    return false;
                }
                return true;
            }
            case STPackageBundle.Webshops: {
                if (pack.meta.type === STPackageType.Webshops) {
                    // Already bought
                    return false;
                }
                return true;
            }
            case STPackageBundle.SingleWebshop: {
                if (pack.meta.type === STPackageType.SingleWebshop || pack.meta.type === STPackageType.Webshops) {
                    // Already bought
                    return false;
                }
                return true;
            }
            case STPackageBundle.TrialMembers: {
                if (pack.meta.type === STPackageType.Members || pack.meta.type === STPackageType.TrialMembers) {
                    // Already bought
                    return false;
                }
                return true;
            }
            case STPackageBundle.TrialWebshops: {
                if (pack.meta.type === STPackageType.SingleWebshop || pack.meta.type === STPackageType.Webshops || pack.meta.type === STPackageType.TrialWebshops) {
                    // Already bought
                    return false;
                }
                return true;
            }
        }
        return false;
    }
    /**
     * Create a new package for this type and return the pricing
     */
    static getCurrentPackage(bundle, date) {
        switch (bundle) {
            case STPackageBundle.Members: {
                // 1 year valid
                const validUntil = new Date(date);
                validUntil.setFullYear(validUntil.getFullYear() + 1);
                // Remove (= not renewable) if not renewed after 1 month
                const removeAt = new Date(validUntil);
                removeAt.setMonth(removeAt.getMonth() + 1);
                return STPackage.create({
                    validUntil,
                    removeAt,
                    meta: STPackageMeta.create({
                        type: STPackageType.Members,
                        unitPrice: 10000, // 1 euro
                        minimumAmount: 0,
                        allowRenew: true,
                        pricingType: STPricingType.PerMember,
                        startDate: new Date(date),
                    }),
                });
            }
            case STPackageBundle.Webshops: {
                return STPackage.create({
                    validUntil: null,
                    removeAt: null,
                    meta: STPackageMeta.create({
                        type: STPackageType.Webshops,
                        unitPrice: 0,
                        minimumAmount: 0,
                        allowRenew: false,
                        pricingType: STPricingType.Fixed,
                        serviceFeeFixed: 0,
                        serviceFeePercentage: 200,
                        serviceFeeMaximum: 2000, // 20 cent
                        startDate: new Date(date),
                        canDeactivate: true,
                    }),
                });
            }
            case STPackageBundle.TrialMembers: {
                // Disable functions after two weeks, manual reenable required
                const validUntil = new Date(date);
                validUntil.setDate(validUntil.getDate() + 14);
                // Remove if not valid anymore
                const removeAt = new Date(validUntil);
                return STPackage.create({
                    validUntil,
                    removeAt,
                    meta: STPackageMeta.create({
                        type: STPackageType.TrialMembers,
                        unitPrice: 0,
                        minimumAmount: 1,
                        allowRenew: false,
                        pricingType: STPricingType.Fixed,
                        startDate: new Date(date),
                        canDeactivate: true,
                    }),
                });
            }
            case STPackageBundle.TrialWebshops: {
                // Disable functions after two weeks, manual reenable required
                const validUntil = new Date(date);
                validUntil.setDate(validUntil.getDate() + 14);
                // Remove if not valid anymore
                const removeAt = new Date(validUntil);
                return STPackage.create({
                    validUntil,
                    removeAt,
                    meta: STPackageMeta.create({
                        type: STPackageType.TrialWebshops,
                        unitPrice: 0,
                        minimumAmount: 1,
                        allowRenew: false,
                        pricingType: STPricingType.Fixed,
                        startDate: new Date(date),
                        canDeactivate: true,
                    }),
                });
            }
        }
        throw new Error('Package not available');
    }
}
//# sourceMappingURL=STPackageBundle.js.map